import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";

// In MUI v5, styled can be used to create styled components directly
const StyledContainer = styled(Box, {
  shouldForwardProp: prop => prop !== "smallInfo"
})(({ theme, smallInfo }) => ({
  "& .titleText": {
    color: "var(--colour-text-primary, #000)",
    fontFamily: "var(--font-family-primary, 'DM Sans')",
    fontSize: "28px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "36px",
    letterSpacing: "var(--font-spacing-regular, 0px)",
    margin: "0",
    [theme.breakpoints.only("xs")]: {
      fontSize: "20px",
      lineHeight: "28px"
    }
  },
  "& .infoText": {
    color: "var(--Color-Text-Secondary-On-Light, #757575)",
    fontFamily: "var(--font-family-primary, 'DM Sans')",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "var(--font-spacing-regular, 0px)",
    display: "block",
    marginTop: "8px !important",
    [theme.breakpoints.only("xs")]: {
      fontSize: smallInfo ? 14 : 16,
      lineHeight: smallInfo ? "20px" : "22px",
      marginTop: smallInfo ? 5 : 10
    }
  }
}));

/**
 * SectionTitleWithInfo component displays a section title with optional information text
 *
 * @param {Object} props - Component props
 * @param {string} props.className - Additional CSS class
 * @param {string} props.title - The title text
 * @param {string} props.info - Optional informational text
 * @param {boolean} props.smallInfo - Whether to use smaller font for info text on mobile
 * @returns {React.ReactElement} - Rendered component
 */
export const SectionTitleWithInfo = ({ className, title, info, smallInfo = true }) => {
  return (
    <StyledContainer className={className} smallInfo={smallInfo}>
      <h3 className="titleText">{title}</h3>
      {info && <span className="infoText">{info}</span>}
    </StyledContainer>
  );
};

SectionTitleWithInfo.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  info: PropTypes.string,
  smallInfo: PropTypes.bool
};
